<template>
    <div>
        <div class="form-container">
            <div class="row justify-content-md-center">
                <div class="col-sm">
                    <InputField
                        :customErrorMessage="$t('form.fields.mobileNumber.errorMessage')"
                        :image="url($t('form.fields.mobileNumber.flagUrl'))"
                        :validationRules="validationRules"
                        :label="$t('form.fields.mobileNumber.label')"
                        name="mobileNumber"
                        ref="mobileNumber"
                        type="tel"
                    />
                </div>
            </div>

            <div class="row justify-content-md-center gy-5" v-if="!hideSMS || showWhatsapp">
                <div class="col-sm">
                    <div v-if="territory == 'usa'" class="block no-logo">
                        <i class="info-icon fal fa-info-circle"></i>
                        {{ $t('form.sections.aboutYou.mobileNumber.optinText') }}
                    </div>

                    <div v-else class="block">
                        <div class="icon">
                            <img :src="asset(`/img/icons/ic_speaker_notes_48px.svg`)" alt="" />
                        </div>
                        <h2>{{ $t('form.sections.aboutYou.mobileNumber.optinHeading') }}</h2>
                        {{ $t('form.sections.aboutYou.mobileNumber.optinText') }}

                        <div class="container p-0">
                            <div class="row checkbox-row" v-if="!hideSMS">
                                <div class="col-auto">
                                    <checkbox name="optSms" label="SMS" :validationRules="null" />
                                </div>

                                <div class="col-sm" v-if="showWhatsapp">
                                    <checkbox name="whatsappConsent" label="Whatsapp" :validationRules="null" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'

function mobileMaxLength() {
    let max

    switch (process.env.TERRITORY) {
        case 'gbr':
            max = 11
            break

        case 'aus':
            max = 12
            break

        case 'usa':
            max = 15
            break

        default:
            max = null
            break
    }

    return max
}

function mobileStartWith() {
    let startWith

    switch (process.env.TERRITORY) {
        case 'gbr':
            startWith = '07'
            break

        case 'aus':
            startWith = ['04', '05']
            break

        default:
            startWith = false
            break
    }

    return startWith
}

function mobileMask() {
    let mask

    switch (process.env.TERRITORY) {
        case 'aus':
            mask = '####-###-###'
            break

        case 'usa':
            mask = '###-###-####'
            break

        default:
            mask = null
            break
    }

    return mask
}

function consents() {
    if (process.env.TERRITORY == 'aus') {
        return {}
    }

    return {
        whatsappConsent: {
            value: null,
            mappedKey: 'whatsapp_consent',
            hideOnSummary: true,
        },
        optSms: {
            value: null,
            mappedKey: 'opt_sms',
            hideOnSummary: true,
        },
    }
}

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'mobileNumber',
            route: {
                relativeUrl: `mobile-number`,
                name: 'apply.mobileNumber',
                meta: {
                    title: 'form.sections.aboutYou.mobileNumber.heading',
                    tooltip: process.env.IS_VERVENT ? 'form.sections.aboutYou.mobileNumber.tooltip' : false,
                },
            },
            fields: {
                mobileNumber: {
                    value: null,
                    mappedKey: 'mobile_phone',
                    legacyMappedKey: 'primary_phone',
                    mask: mobileMask(),
                    validationRules: {
                        required: true,
                        max: mobileMaxLength(),
                        startsWith: mobileStartWith(),
                        loqateMobilePhone: true,
                    },
                },
                ...consents(),
            },
        }
    },

    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    mounted() {
        this.autoFocus(this.$refs.mobileNumber)
    },
    created() {
        this.emitter.emit('stepLoaded')

        if (this.includeTerritories('usa') && this.$store.state.global.data?.loqate_mobile_phone === '0') {
            this.store.dispatch('updateValidationRules', {
                field: 'mobileNumber',
                rules: {
                    loqateMobilePhone: false,
                    phoneUS: true,
                },
            })
        }
    },
    computed: {
        showWhatsapp: function () {
            return this.$store.state.global.page.show_whatsapp_consent === 1
        },
        hideSMS: function () {
            return this.$store.state.global.page.hide_sms_consent === 1
        },
        validationRules: function () {
            return this.$store.getters.fieldValidationRules('mobileNumber')
        },
        territory: function () {
            return process.env.TERRITORY
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';

.block {
    text-align: left;
    position: relative;
    background: #f4f5f6;
    padding: 26px 24px 24px 95px;
    margin: 20px 0;
    font-size: 0.6rem;
    color: #525252;

    &.no-logo {
        padding-left: 40px;
    }

    h2 {
        font-size: rem(18px);
        font-weight: bold;
        margin-bottom: 20px;
        color: #242a2f;
    }

    .icon {
        position: absolute;
        left: 24px;
        top: 26px;
        font-size: rem(18px);
        background: #3380e3;
        color: #fff;
        padding: 10px;
        border-radius: 50%;
    }

    .info-icon {
        color: #3380e3;
        font-size: rem(18px);
        left: 14px;
        position: absolute;
        top: 28px;
    }

    .checkbox-row {
        padding-top: 20px;
        font-weight: bold;
        color: #242a2f;
    }
}
</style>
